import { useTranslation } from 'react-i18next';
import PayPalMonogram from '../../sharedComponents/assets/svg-base/providerLogos/paypal-monogram.svg';
import { PayPalLoginButtonProps } from './PayPalLoginButton.types';
import styles from './paypal-login-button.module.scss';

const PayPalLoginButton: React.FC<PayPalLoginButtonProps> = ({
  disabled = false,
  onClick,
}) => {
  const { t } = useTranslation();
  const label = t('sunshine.action.log_in_paypal');

  return (
    <button
      aria-label={label}
      className={styles.button}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      <img alt="" className={styles.logo} src={PayPalMonogram} />
      <span>{label}</span>
    </button>
  );
};

export default PayPalLoginButton;
